module.exports = __webpack_public_path__ + "static/realisations.1d70baee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/img/realisations.jpg
// module id = 837
// module chunks = 219805994829571